const STEPS = [
  {
    number: "01",
    icon: "ri-phone-line",
    title: "예약 문의",
    desc: "전화 또는 온라인으로 편한 시간에 예약해주세요.",
  },
  {
    number: "02",
    icon: "ri-scan-line",
    title: "피부 진단",
    desc: "방문 시 정밀 장비로 피부 상태를 꼼꼼히 진단합니다.",
  },
  {
    number: "03",
    icon: "ri-draft-line",
    title: "맞춤 상담",
    desc: "피부 고민과 목표를 듣고 최적의 프로그램을 제안합니다.",
  },
  {
    number: "04",
    icon: "ri-hand-heart-line",
    title: "전문 관리",
    desc: "전문 관리사의 세심한 손길로 관리를 시작합니다.",
  },
];

export default function ReservationSteps() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
      {STEPS.map((step) => (
        <div
          key={step.number}
          className="relative flex flex-col items-center gap-4 p-7 rounded-2xl bg-white border border-background-200/70 text-center"
        >
          <div className="relative">
            <span className="w-16 h-16 rounded-full bg-primary-50 flex items-center justify-center">
              <i className={`${step.icon} text-3xl text-primary-500`}></i>
            </span>
            <span className="absolute -top-1 -right-1 w-7 h-7 rounded-full bg-primary-500 text-white text-xs font-bold flex items-center justify-center">
              {step.number}
            </span>
          </div>
          <div className="flex flex-col gap-1.5">
            <h3 className="text-base font-semibold text-foreground-900">{step.title}</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
          </div>
        </div>
      ))}
    </div>
  );
}